<template>
  <div id="app">
   <vue-confirm-dialog></vue-confirm-dialog>
    <Flash :details="{}" />

    <div>
      <router-view />
    </div>

  </div>
</template>

<script>
  import Flash from '@/components/widgets/Flash'
  import { logout } from "@/utils/Customs";
  export default {
    name: 'App',
    components: {
      Flash,
    },
    data() {
      return {
        active: 0,
      }
    },
    created() {
      Event.listen('APP_LOGOUT', component => {
        logout()
        this.$router.push('/login')
      })
    }
  }
</script>

<style>

@font-face {
    font-family: 'Gotham-Black';
    src: url("fonts/Gotham-Black.otf") format("opentype");
}
@font-face {
    font-family: 'Gotham-BlackItalic';
    src: url("fonts/Gotham-BlackItalic.otf") format("opentype");
}
@font-face {
    font-family: 'Gotham-Bold';
    src: url("fonts/Gotham-Bold.otf") format("opentype");
}
@font-face {
    font-family: 'Gotham-BoldItalic';
    src: url("fonts/Gotham-BoldItalic.otf") format("opentype");
}
@font-face {
    font-family: 'Gotham-Light';
    src: url("fonts/Gotham-Light.otf") format("opentype");
}
@font-face {
    font-family: 'Gotham-Medium';
    src: url("fonts/Gotham-Medium.otf") format("opentype");
}

.vs-component.vs-button.butonlar.vs-button-success.vs-button-gradient.includeIcon{
    width:100%;
}

.vs-select--item{
  font-size: 12px;
}
.vs-table-text{
  margin-left:0px;
}
th{
    border: 0 !important;;
    text-align: left !important;;
    font-size: 0.85rem !important;;
     padding: 0 !important;
      padding-top: 10px !important;
}
.fontt3{
  width:5%;
}

.eklemegenis{
  width:100%;
}
.silgenis{
  width:100%;
}

.fontOnay{
  
  font-weight: 1000 !important;
}
.magniclass{
  background: red !important;
}
.vs-con-table.stripe .tr-values:nth-child(2n) {
    background: #F0F0F0 !important;
}
.vs-button-warning.vs-button-border, .vs-button-warning.vs-button-flat {
    border: 1px solid black !important;
    background: transparent !important;
    color: black !important;
}
.vs-pagination--li.is-current .effect{
      background-color: #E6272D !important;
      border-radius:25px;
  }

  
  .edit-form {
    width: 70% !important;
    margin: auto;
  }
  .alanlar{
    width: 100% !important;
  }
  .logosize{
    height:50px !important;
    margin-left:8
    5%;
  }

  .con-vs-popup .vs-popup {
    -webkit-transition: all 0.2s;
    transition: all 0.2s;
    z-index: 100;
    width: 60% !important;
    margin: 10px;
    max-width: calc(100% - 30px);
    max-height: calc(100% - 30px);
    border-radius: 6px;
    -webkit-box-shadow: 0 5px 20px 0 rgb(0 0 0 / 10%);
    box-shadow: 0 5px 20px 0 rgb(0 0 0 / 10%);
    background: #fff;
    -webkit-animation: rebound 0.3s;
    animation: rebound 0.3s;
}
</style>